"use client";

import React from "react";
import Link from "next/link";
import Image from "next/image";
import styles from "./WebsocketUpgrade.module.css";
import { websocketUpgradeFeatures as FEATURES } from "../../data/custom-software-integration";

export default function WebsocketUpgrade({ dynamicData }) {
  // Determine if we use dynamic or static data
  const displayTitle = dynamicData?.title || "Custom Websocket Upgrade Services";
  const displaySubtitle = dynamicData?.subtitle || "We create tailored WebSocket solutions that establish a single TCP connection between the server and client, enabling real-time, bidirectional communication.";

  // Normalizing points/features
  const displayFeatures = dynamicData?.points?.map(f => ({
    title: f.title,
    icon: f.icon,
    desc: f.description || f.desc
  })) || FEATURES;

  const displayImage = dynamicData?.image
    ? (dynamicData.image.startsWith('http') ? encodeURI(dynamicData.image) : `${process.env.NEXT_PUBLIC_API_URL || ""}${encodeURI(dynamicData.image)}`)
    : "/assets/img/custom-software/system-intergate-right.webp";

  const displayCtaText = dynamicData?.buttonText || "Get Websocket Solution";
  const displayCtaLink = dynamicData?.buttonLink || "/contact";

  return (
    <section className={`${styles.section} py-5`}>
      <div className="container">
        <div className={styles.head} data-reveal="fade">
          <div className={styles.eyebrow}>UPGRADE</div>
          <h2 className={styles.title}>{displayTitle}</h2>
          <p className={styles.subtitle}>{displaySubtitle}</p>
        </div>

        <div className={styles.grid} data-reveal="stagger-mix">
          {/* Left features */}
          <div className={styles.list}>
            {displayFeatures.map((f, i) => (
              <div key={i} className={styles.item}>
                <span className={styles.bullet} aria-hidden>
                  <i className={f.icon}></i>
                </span>
                <div>
                  <h3 className={styles.ititle}>{f.title}</h3>
                  <p className={styles.idesc}>{f.desc}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Right visual */}
          <div className={styles.visual}>
            <div className={styles.visualCard}>
              <div className={styles.imgWrap}>
                <Image
                  src={displayImage}
                  alt={displayTitle}
                  fill
                  unoptimized
                  className={styles.img}
                  sizes="(min-width: 992px) 520px, 90vw"
                  priority={false}
                />
              </div>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className={styles.ctaWrap} data-reveal="slide-up">
          <Link href={displayCtaLink} className={styles.ctaBtn}>
            {displayCtaText}
          </Link>
        </div>
      </div>
    </section>
  );
}
